import React from 'react';
import SlideUpDownNav from './../inc/SlideUpDownNav';


class Services extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <section className="section" data-anchor="services" data-logo="hide">
                <SlideUpDownNav {...this.props} fullpageApi={this.props.fullpageApi} />
                
                <div className="mole__about--slide-content fullW">
                    <div className="main-container">
                        <div className="inner-container">
                            <h4 className="font-lg section--title c-general">Services</h4>
                            <div className="grid grid-4 fullW font-md">
                                <div className="grid-item desc">
                                    <p className="c-general">Full-Service Architecture</p>
                                    <p className="mb-0">&nbsp;</p>
                                    <p>Our urban and regeneration
                                    strategies celebrate local
                                    heritage and identity,
                                    ecology and everyday life.
                                    We have close working
                                    relationships with leading
                                    consultants in landscaping,
                                    engineering, lighting and
                                    highways, with whom we
                                    have devised strategy
                                    documents and masterplans
                                    for key urban and rural sites.
                                    See Soar Island and
                                    Kingston Mini Holland,
                                    two of our neighbourhood
                                    design projects.</p>
                                </div>

                                <div className="grid-item desc">
                                    <p className="c-general">Sustainable Design <br/>and Passivhaus</p>
                                    <p>Our urban and regeneration
                                    strategies celebrate local
                                    heritage and identity,
                                    ecology and everyday life.
                                    We have close working
                                    relationships with leading
                                    consultants in landscaping,
                                    engineering, lighting and
                                    highways, with whom we
                                    have devised strategy
                                    documents and masterplans
                                    for key urban and rural sites.
                                    See Soar Island and
                                    Kingston Mini Holland,
                                    two of our neighbourhood
                                    design projects.</p>
                                </div>

                                <div className="grid-item desc">
                                    <p className="c-general">Masterplanning and <br/>Urban Design</p>
                                    <p>Our urban and regeneration
                                    strategies celebrate local
                                    heritage and identity,
                                    ecology and everyday life.
                                    We have close working
                                    relationships with leading
                                    consultants in landscaping,
                                    engineering, lighting and
                                    highways, with whom we
                                    have devised strategy
                                    documents and masterplans
                                    for key urban and rural sites.
                                    See Soar Island and
                                    Kingston Mini Holland,
                                    two of our neighbourhood
                                    design projects.</p>
                                </div>

                                <div className="grid-item desc">
                                    <p className="c-general">Co-design and Collaboration</p>
                                    <p className="mb-0">&nbsp;</p>
                                    <p>Our urban and regeneration
                                    strategies celebrate local
                                    heritage and identity,
                                    ecology and everyday life.
                                    We have close working
                                    relationships with leading
                                    consultants in landscaping,
                                    engineering, lighting and
                                    highways, with whom we
                                    have devised strategy
                                    documents and masterplans
                                    for key urban and rural sites.
                                    See Soar Island and
                                    Kingston Mini Holland,
                                    two of our neighbourhood
                                    design projects.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        );
    }
}
export default Services;



// WEBPACK FOOTER //
// ./src/components/About/Services.js